<div class="custom-popup-container"
     (click)="$event.stopPropagation()"
>

  <div class="main">
    <div class="custom-popup-header">
      <div class="title" *ngIf="objectName">
        {{objectName}} [{{pin?.bimElementId}}]
      </div>

    </div>
    <div class="custom-popup-action-buttons"
    >
      <button class="more-info-button" mat-button (click)="moreInfoClick($event)"
              *ngIf="!(creationService.bimViewerData?.viewerService?.propertyVisibilityState$ | async); else  hideProperties">
        {{ "MM.bimViewer.objectSelectedPopup.moreInfoButton" | translate}}
      </button>
      <ng-template #hideProperties>
        <button class="more-info-button" mat-button (click)="hidePanel($event)">
          {{ "MM.bimViewer.objectSelectedPopup.hideInfoButton" | translate}}
        </button>
      </ng-template>
      <button *ngIf="creationService.creationState === enumCreationState.ObjectSelected" mat-icon-button
              class="done-button" (click)="onDoneClick($event)">
        <mat-icon>
          done
        </mat-icon>
      </button>
    </div>
  </div>
  <div class="close-button">
    <mat-icon (click)="close($event)">
      close
    </mat-icon>
  </div>


</div>
